import axios from 'axios';

// 使用百炼应用API测试
export const simplestApiTest = async () => {
  try {
    console.log('开始百炼应用API测试');
    
    const apiKey = 'sk-c4e0665e71d34746999da6260362d0f4';
    const appId = '27dc9d32200d4a59ade097778a894605';
    
    const response = await axios.post(`https://dashscope.aliyuncs.com/api/v1/apps/${appId}/completion`, {
      input: {
        prompt: "你好，请简单介绍一下中医基础"
      },
      parameters: {}
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`
      }
    });
    
    console.log('百炼应用响应:', response.data);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('百炼应用调用错误:', error);
    return {
      success: false,
      error: error.message,
      details: error.response?.data || {}
    };
  }
};

// 通过代理调用测试
export const proxyApiTest = async () => {
  try {
    console.log('开始代理API测试');
    
    const response = await axios.post('/api/consultation', {
      prompt: "请简单介绍一下中医的阴阳五行学说"
    });
    
    console.log('代理测试响应:', response.data);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('代理测试错误:', error);
    return {
      success: false,
      error: error.message,
      details: error.response?.data || {}
    };
  }
}; 